<template>
  <PreloaderComponent v-show="!isLoaded" />
  <div v-show="isLoaded" class="lsl">
    <p class="lsl__header">Заявление о страховой выплате по риску "Дожитие"</p>
    <p class="lsl__contract" v-if="contract.number && contract.date">
      {{ contractInfoComputed }}
    </p>
    <p class="lsl__text lsl__text_mt">
      Уважаемый клиент, перед подачей заявления о страховой выплате, пожалуйста, ознакомьтесь с
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/73d/ts5nj0cfs251uzammcxhnu3oqbo8jo04/%D0%9F%D0%B0%D0%BC%D1%8F%D1%82%D0%BA%D0%B0%20%D0%BF%D1%80%D0%B8%20%D0%BD%D0%B0%D1%81%D1%82%D1%83%D0%BF%D0%BB%D0%B5%D0%BD%D0%B8%D0%B8%20%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%BE%D0%B3%D0%BE%20%D1%81%D0%BE%D0%B1%D1%8B%D1%82%D0%B8%D1%8F%20%D0%B2%D1%8B%D0%BF%D0%BB%D0%B0%D1%82%D0%B0%20%D0%BF%D0%BE%20%D0%BE%D0%BA%D0%BE%D0%BD%D1%87%D0%B0%D0%BD%D0%B8%D1%8E%20%D0%BF%D1%80%D0%BE%D0%B3%D1%80%D0%B0%D0%BC%D0%BC%D1%8B.pdf">памяткой</a>,
      в которой находятся все необходимые данные о перечне документов, которые необходимо предоставить в компанию.
    </p>
    <br>
    <p class="lsl__text">Если вы желаете заполнить заявления вручную, можете
      <a target="_blank"
         href="https://makclife.ru/upload/medialibrary/8b3/qxfjlui4612xvplsqum0v490n3ge0d9n/%D0%97%D0%B0%D1%8F%D0%B2%D0%BB%D0%B5%D0%BD%D0%B8%D0%B5%20%D0%BE%20%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%BE%D0%B9%20%D0%B2%D1%8B%D0%BF%D0%BB%D0%B0%D1%82%D0%B5%20%D0%94%D0%BE%D0%B6%D0%B8%D1%82%D0%B8%D0%B5%20%D0%B4%D0%BE%20%D0%BE%D0%BA%D0%BE%D0%BD%D1%87%D0%B0%D0%BD%D0%B8%D1%8F%20%D1%81%D1%80%D0%BE%D0%BA%D0%B0%20%D1%81%D1%82%D1%80%D0%B0%D1%85%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F.pdf">скачать
        бланк</a> заявления.
    </p>
    <div class="lsl__statement-div">
      <label>
        <input type="radio" name="type" id="type" @click="errors = []; files= []" v-model="type" :value="'e_statement'">
        <span>Электронное заявление</span>
      </label>
      <label>
        <input type="radio" name="type" id="type" @click="errors = []; files= []" v-model="type" :value="'f_statement'">
        <span>Заявление, заполненное вручную</span>
      </label>
    </div>
    <p v-if="type === 'e_statement'" class="lsl__subheader">Сведения о Заявителе</p>
    <div v-if="type === 'e_statement'" class="lsl__infoWrapper">
      <div class="lsl__infoWrapper-row">
        <div class="lsl__infoWrapper-input">
          <label v-if="client.full_name">ФИО</label>
          <MakcInputComponent
            type="text"
            placeholder="ФИО"
            :class="v$.client.full_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.client.full_name.$model"
            :isDisabled="client.full_name.length > 0"
          />
        </div>
        <div class="lsl__infoWrapper-input">
          <label v-if="client.birth_date">Дата рождение</label>
          <MakcInputComponent
            type="text"
            placeholder="Дата рождение"
            :class="v$.client.birth_date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.client.birth_date.$model"
            :isDisabled="client.birth_date.length > 0"
          />
        </div>
        <div class="lsl__infoWrapper-input">
          <label>Телефон</label>
          <div class="makc-input-wrapper" :class="v$.client.phone.$errors.length > 0 ? 'field-error' : ''">
            <input
              v-model="v$.client.phone.$model"
              type="text"
              placeholder=""
              v-mask="{
                      mask: '+7 (F##) ###-##-##',
                      tokens: {
                        F: {
                          pattern: /(?!8)\d/,
                        },
                        '#': { pattern: /\d/ },
                      },
                    }"
            />
          </div>
          <ValidationErrorComponent :errors="v$.client.phone.$errors" />
        </div>
      </div>
      <span class="xxxx">Документ, удостоверяющий личность</span>
      <div class="lsl__infoWrapper-row lsl__infoWrapper-row_mt">
        <div class="lsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Серия"
            :class="v$.doc.serial.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.serial.length > 0"
            v-model="v$.doc.serial.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.serial.$errors" />
        </div>
        <div class="lsl__infoWrapper-input">
          <MakcInputComponent
            type="text"
            placeholder="Номер"
            :class="v$.doc.number.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.number.length > 0"
            v-model="v$.doc.number.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.number.$errors" />
        </div>
      </div>
      <div class="lsl__infoWrapper-row lsl__infoWrapper-row_mt2">
        <div class="lsl__infoWrapper-input lsl__infoWrapper-input_width">
          <MakcInputComponent
            type="text"
            placeholder="Кем выдан паспорт"
            :class="v$.doc.auth.$errors.length > 0 ? 'field-error' : ''"
            :isDisabled="doc.auth.length > 0"
            v-model="v$.doc.auth.$model"
          />
          <ValidationErrorComponent :errors="v$.doc.auth.$errors" />
        </div>
      </div>
    </div>
    <div v-if="type === 'e_statement'" class="lsl__xxxxWrapper">
      <h3>Прошу произвести страховую выплату по договору страхования</h3>
      <span class="lsl__xxxxWrapper-span">в связи с дожитием застрахованного лица:</span>
      <div class="lsl__xxxxWrapper-row">
        <div class="lsl__xxxxWrapper-input">
          <label>Номер договора страхования</label>
          <MakcInputComponent
            type="text" placeholder=""
            :isDisabled="contract.number.length > 0"
            :class="v$.contract.number.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.contract.number.$model"
          />
          <ValidationErrorComponent :errors="v$.contract.number.$errors" />
        </div>
        <div class="lsl__xxxxWrapper-input">
          <label>Дата договора страхования</label>
          <input
            type="date" :max="dateNow" class="lsl__dateInput"
            :disabled="contract.date.length > 0"
            :class="v$.contract.date.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.contract.date.$model"
          >
          <ValidationErrorComponent :errors="v$.contract.date.$errors" />
        </div>
      </div>
    </div>
    <div v-if="type === 'e_statement'" class="lsl__xxxxWrapper">
      <h3>Страховую выплату прошу перечислить по следующим реквизитам</h3>
      <div class="lsl__xxxxWrapper-row mtX">
        <div class="lsl__xxxxWrapper-input">
          <label>БИК</label>
          <MakcInputComponent
            type="text"
            @input="autoComplit"
            :class="v$.requisites.bik.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.bik.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.bik.$errors" />
          <div v-if="autoComplitData.length > 0" class="bik-autocomplete">
            <p v-for="(item, i) of autoComplitData" :key="i" @click="atoInHtml(item)">
              {{ item.label }}
            </p>
          </div>
        </div>
        <div class="lsl__xxxxWrapper-input">
          <label>Корреспондентский счет банка</label>
          <MakcInputComponent
            :fieldType="'number'"
            :class="v$.requisites.ks.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.ks.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.ks.$errors" />
        </div>
      </div>
      <div class="lsl__xxxxWrapper-row mtY">
        <div class="lsl__xxxxWrapper-input">
          <label>Наименование банка</label>
          <MakcInputComponent
            type="text"
            :class="v$.requisites.bank_name.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.bank_name.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.bank_name.$errors" />
        </div>
        <div class="lsl__xxxxWrapper-input">
          <label>Расчетный счет</label>
          <MakcInputComponent
            type="text"
            :fieldType="'number'"
            :class="v$.requisites.rs.$errors.length > 0 ? 'field-error' : ''"
            v-model="v$.requisites.rs.$model"
          />
          <ValidationErrorComponent :errors="v$.requisites.rs.$errors" />
        </div>
      </div>
    </div>
    <div :class="type === 'e_statement' ? 'mtN' : 'mtN mtN_f'">
      <div v-show="fileInputShow">
        <MakcFilesComponent
          :text="type === 'e_statement' ? '' : 'Отправка дополнительных документов'"
          @load="loadFiles($event)"
          ref="lslFile"
        />
      </div>
      <p v-if="sended"> Данные отправляются, ожидайте</p>
      <div v-if="errors.length > 0" class="errors">
        <div v-for="(error, key) in errors" :key="key" class="error">
          {{ error }}
        </div>
      </div>
      <div class="mtK">
        <label v-if="type === 'f_statement'" class="icsl-file" for="icsl-file">Дослать документы</label>
        <input v-if="type === 'f_statement'" id="icsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle"
               style="display: none;">
        <MakcButtonComponent
          :disabled="!agree || sended" @click="sendData" class="primary"
        >
          Отправить заявление
        </MakcButtonComponent>
        <label v-if="type === 'e_statement'" class="icsl-file" for="icsl-file">Вложить дополнительный документ</label>
        <input v-if="type === 'e_statement'" id="icsl-file" type="file" name="files" :multiple="true"
               @change="fileInputHandle"
               style="display: none;">
        <MakcButtonComponent :disabled="sended" @click="modal_canceling_show = true">
          Отменить
        </MakcButtonComponent>
      </div>
    </div>
    <div class="mtP">
      <input type="checkbox" name="agree" v-model="agree">
      <p>
        Декларация Заявителя:
        <br>1. Настоящим Заявитель подтверждает, что не имеет гражданства США, разрешения на постоянное пребывание в
        США и
        не является налоговым резидентом США.
        <br>2. Настоящим Заявитель подтверждает, что не является:
        <br><span class="mr-2"></span>а) иностранным публичным должностным лицом, должностным лицом публичных
        международных организаций;
        <br><span class="mr-2"></span>б) лицом, замещающим (занимающим) государственные должности РФ, должности членов
        Совета директоров ЦБ РФ,
        должности федеральной государственной службы, назначение на которые и освобождение от которых осуществляется
        Президентом РФ или Правительством РФ, должности в ЦБ РФ, государственных корпорациях и иных организациях,
        созданных РФ на основании федеральных законов, включенные в перечни должностей, определяемые Президентом РФ;
        <br><span class="mr-2"></span>в) супругой(-ом), близким родственником лиц, указанных в настоящем подпункте.
      </p>
    </div>
  </div>
  <MakcDialogComponent
    :title="'Заявление успешно подано!'"
    :text="'Отслеживать статус заявления можно в разделе “Поданные заявления”'"
    :icon="'success'"
    :width="'607px'"
    btn_text="ОК"
    @close_modal="$router.push({name: 'contract', params: {id: id}})"
    v-model:show="modal_show"
  />
  <MakcDialogComponent
    :title="'Подача заявления отменена'"
    :text="''"
    :icon="'success'"
    :width="'607px'"
    btn_text="OK"
    @close_modal="$router.push({name: 'services'})"
    v-model:show="modal_canceling_show"
  />
</template>

<script>
import PreloaderComponent from "@/profile/components/PreloaderComponent.vue";
import MakcInputComponent from "@/profile/components/UI/MakcInputComponent";
import MakcButtonComponent from "@/profile/components/UI/MakcButtonComponent";
import MakcFilesComponent from "@/profile/components/UI/MakcFilesComponent";
import MakcDialogComponent from "@/profile/components/UI/MakcDialogComponent";
import ValidationErrorComponent from "@/profile/components/ValidationErrorComponent.vue";
import axios from "axios";
import { url } from "@/profile/composables/url";
import { mask } from "vue-the-mask";
import { formatDate } from "@/profile/composables/utils";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength, minLength, integer } from "@vuelidate/validators";

export default {
  name: "LivingStatement",
  components: {
    ValidationErrorComponent,
    MakcInputComponent,
    MakcButtonComponent,
    MakcFilesComponent,
    MakcDialogComponent,
    PreloaderComponent
  },
  props: {
    id: {
      type: Number || String
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      client: {
        full_name: "",
        birth_date: "",
        phone: ""
      },
      doc: {
        serial: "",
        number: "",
        date: "",
        auth: ""
      },
      contract: {
        number: "",
        date: ""
      },
      requisites: {
        bank_name: "",
        bik: "",
        rs: "",
        ks: ""
      },
      errors: [],
      isChecked: false,
      files: [],
      autoComplitData: [],
      type: "e_statement",
      agree: false,
      sended: false,
      modal_show: false,
      modal_canceling_show: false,
      risk_id: false,
      risk_row: false,
      fileInputShow: false,
      isLoaded: false
    };
  },
  computed: {
    dateNow() {
      return new Date().toISOString().slice(0, 10);
    },
    contractInfoComputed() {
      return `Договор ${this.contract.number} от ${formatDate(this.contract.date)}`;
    }
  },
  validations() {
    return {
      client: {
        full_name: { required },
        birth_date: { required },
        phone: { required }
      },
      doc: {
        serial: { required },
        number: { required },
        auth: { required, maxLength: maxLength(200) }
      },
      contract: {
        number: { required },
        date: { required }
      },
      requisites: {
        bank_name: { required, maxLength: maxLength(200) },
        bik: { required, minLength: minLength(9), maxLength: maxLength(9), integer },
        rs: { required, minLength: minLength(20), maxLength: maxLength(20), integer },
        ks: { required, minLength: minLength(20), maxLength: maxLength(20), integer }
      }
    };
  },
  directives: { mask },
  methods: {
    loadFiles(item) {
      this.files = item;
    },
    async sendData() {
      this.errors = [];
      let d = new Date();
      let size = 0;
      for (let i = 0; i < this.files.length; i++) {
        size += this.files[i].file_size / 1048576;
      }

      if (size > 30) {
        this.errors.push("общий размер добавляемых файлов не может быть более 30МБ");
        return;
      }

      let params;

      if (this.v$.$invalid) {
        this.v$.$touch();
        if (this.type === "f_statement") {
          if (this.files.length === 0) {
            this.errors.push("Приложите заявление");
            return;
          }
          if (this.risk_row) {
            params = {
              command: "send_living",
              contract_id: this.id,
              files: this.files,
              type: this.type,
              ins_date: d.toLocaleDateString("ru-RU"),
              token: this.$myApp.token.get(),
              risk_row: this.risk_row,
              risk_id: this.risk_id
            };
          } else {
            params = {
              command: "send_living",
              contract_id: this.id,
              files: this.files,
              type: this.type,
              ins_date: d.toLocaleDateString("ru-RU"),
              token: this.$myApp.token.get()
            };
          }
        } else {
          this.errors.push("Для отправки заявления, пожалуйста, заполните все обязательные поля");
          return;
        }
      } else { // электронное
        if (this.risk_id) {
          params = {
            command: "send_living",
            contract_id: this.id,
            files: this.files,
            type: this.type,
            ins_date: d.toLocaleDateString("ru-RU"),
            token: this.$myApp.token.get(),
            bik: this.requisites.bik,
            bank_name: this.requisites.bank_name,
            bank_account: this.requisites.rs,
            cor_account: this.requisites.ks,
            risk_row: this.risk_row,
            risk_id: this.risk_id
          };
        } else {
          params = {
            command: "send_living",
            contract_id: this.id,
            files: this.files,
            type: this.type,
            ins_date: d.toLocaleDateString("ru-RU"),
            token: this.$myApp.token.get(),
            bik: this.requisites.bik,
            bank_name: this.requisites.bank_name,
            bank_account: this.requisites.rs,
            cor_account: this.requisites.ks
          };
        }
      }
      this.sended = true;
      let { data } = await axios.post(url, { params: params });
      if (data.state === "ERR") {
        this.errors.push(data.msg_text);
        this.sended = false;
      }
      if (data.state === "OK") {
        this.modal_show = true;
        this.sended = false;
      }
    },
    async fetchData(params) {
      try {
        // eslint-disable-next-line eqeqeq
        let { data } = await axios.post(url, { params: params });
        this.client = data.result.client;
        this.client.full_name = `${data.result.client.last_name} ${data.result.client.first_name} ${data.result.client.middle_name}`;
        this.client.birth_date = formatDate(data.result.client.birth_date);
        if (data.result.client.phone === "+70000000000" || data.result.client.phone === "+73000000000") {
          this.client.phone = ''
        }
        this.doc = data.result.doc;
        this.doc.serial = data.result.doc.serial_number.replace(/\s+/g, "").slice(0, 4);
        this.doc.number = data.result.doc.serial_number.replace(/\s+/g, "").slice(4);
        this.doc.date = data.result.doc.date;
        this.contract = data.result.contract;
        this.contract.date = data.result.contract.date;
        this.isLoaded = true;
        if (data.risk_row) {
          this.risk_row = data.risk_row;
          this.risk_id = data.risk_id;
        }
      } catch (e) {
        this.errors = [];
        this.errors.push(e);
        this.isLoaded = true;
      }
    },
    atoInHtml(item) {
      this.requisites.bank_name = item.id;
      this.requisites.ks = item.cor_acc;
      this.requisites.bik = item.bic;
      this.autoComplitData = [];
    },
    async autoComplit() {
      let params = {
        command: "autocomplit",
        action: "bic",
        term: this.requisites.bik,
        token: this.$myApp.token.get()
      };
      try {
        let { data } = await axios.post(url, { params: params });
        if (data.state === "ERR") {
          if (data.detailed === "Не указано term") {
            console.log(data);
          } else {
            this.errors = [];
            this.errors.push(data.msg_text);
            console.log(data);
          }
        }
        if (data.state === "OK") {
          this.autoComplitData = data.data;
        }
      } catch (e) {
        this.errors = [];
        this.errors.push(e);
      }
    },
    fileInputHandle(e) {
      this.fileInputShow = true;
      this.$refs.lslFile.loadFiles(e);
    }
  },
  mounted() {
    let params = {
      command: "living_contract",
      token: this.$myApp.token.get(),
      contract_id: this.id
    };
    this.fetchData(params);
  }
};
</script>

<style lang="scss" scoped>
.field-error {
  border: 2px solid red !important;
  outline: 2px solid red !important;
}

.makc-input-wrapper {
  position: relative;

  input {
    width: 100%;
    padding: 7px 10px;
    outline: none;
    border: 1px solid #b8b8b8;
  }

  input:disabled {
    background-color: #ecebeb;
  }
}
</style>
